import React from "react";

import { Form, Input, Select, Button, Col, Row } from "antd";
import { v4 as uuidv4 } from "uuid";

function BillingInformation({ accounts, setAccounts }) {
  console.log("accountsaccountsaccounts", accounts);
  const addAccount = () => {
    const newAccount = {
      id: uuidv4(),
      account: "",
      descriptions: "",
      amount: "",
    };

    setAccounts((prevAccounts) => [...prevAccounts, newAccount]);
  };

  const removeAccount = (id) => {
    const updatedAccounts = accounts.filter((item) => {
      return item.id !== id;
    });
    setAccounts(updatedAccounts);
  };

  const handleChange = (value, name, id) => {
    const updatedAccounts = accounts.map((item) => {
      if (item.id === id) {
        return { ...item, [name]: value };
      }
      return item;
    });
    setAccounts(updatedAccounts);
  };

  let totalAmount = 0;

  for (let i = 0; i < accounts.length; i++) {
    totalAmount = totalAmount + Number(accounts[i].amount);
  }

  const accountType = [
    { value: "Insurance Service" },
    { value: "Lease Break Fee" },
    { value: "Integrity Lease Break Fee" },
    { value: "Lease Prep Fee" },
  ];
  return (
    <ul>
      <Row style={{ marginBottom: 12 }}>
        <Col className="tableHead" span={9}>
          <p>Account</p>
        </Col>
        <Col className="tableHead" span={9}>
          <p>Statement Description</p>
        </Col>
        <Col className="tableHead" span={5}>
          <p>Amount</p>
        </Col>
        <Col span={1}></Col>
      </Row>
      {accounts?.map((item) => (
        <li key={item.id}>
          <Form.Item label="">
            <Row>
              <Col span={9}>
                <Form.Item label=" ">
                  <Select
                    showSearch
                    options={accountType}
                    defaultValue={accountType[0]}
                    style={{ width: "100%" }}
                    onChange={(value) =>
                      handleChange(value, "account", item.id)
                    }
                  />
                </Form.Item>
              </Col>
              <Col span={9}>
                <Form.Item label="  ">
                  <Input
                    onChange={(e) =>
                      handleChange(
                        e.target.value,
                        "statementDescription",
                        item.id
                      )
                    }
                  />
                </Form.Item>
              </Col>
              <Col span={5}>
                <Form.Item label="  ">
                  <Input
                    type="Number"
                    prefix="$"
                    onChange={(e) =>
                      handleChange(e.target.value, "amount", item.id)
                    }
                  />
                </Form.Item>
              </Col>
              <Col span={1}>
                {accounts.length > 1 ? (
                  <Button
                    className="roundSmallButton"
                    onClick={() => {
                      removeAccount(item.id);
                    }}
                    type="primary"
                    shape="circle"
                    icon={<i className="fa-sharp fa-solid fa-xmark"></i>}
                    size={"small"}
                  />
                ) : (
                  <></>
                )}
              </Col>
            </Row>
          </Form.Item>
        </li>
      ))}
      <Form.Item label="">
        <Button
          className="addPropertyGroupButton"
          type="primary"
          onClick={addAccount}
          size={"small"}
          icon={<i className="fa-solid fa-circle-plus"></i>}
        >
          Add Another Line
        </Button>
      </Form.Item>
      <Row>
        <Col span={18}></Col>
        <Col span={4}>
          <h4>Total: </h4>
        </Col>
        <Col span={2}>
          <h4>$ {totalAmount}.00 </h4>
        </Col>
      </Row>
    </ul>
  );
}

export default BillingInformation;
